<template>
  <div v-if="!isEdit" class="w-full sm:max-w-368 px-16 sm:px-0">
    <slot></slot>
    <form v-if="hasAvailabilityData" class="flex flex-col mt-24" @submit.prevent="submitForm">
      <h1 class="text-h3 mb-16">Confirm your availability</h1>
      <p class="text-body mb-24">This Adventure availability comes from your babysitter profile. Make sure it’s up-to-date.</p>
      <AvailabilityTable class="mb-24" :availability="availabilityData" />
      <Button value="Edit" variant="outlined" size="medium" class="w-full mb-32" to="/adventures/new/availability/edit" />
      <StickyButton value="Next" />
    </form>
    <div v-else class="flex flex-col mt-24">
      <h1 class="text-h3 mb-16">Add your availability</h1>
      <p class="text-body mb-24">
        Add your up-to-date availability to your babysitter profile so parents know when you can lead this Adventure
      </p>
      <div
        class="w-full mt-8 sm:mt-0 fixed sm:static bottom-0 left-0 p-16 sm:p-0 border-t-1 border-solid border-grey-divider-subdued bg-foreground sm:border-0"
      >
        <Button value="Add Availability" variant="outlined" size="medium" class="w-full" to="/adventures/new/availability/edit" />
      </div>
    </div>
  </div>
  <div v-else-if="isEdit" class="w-full sm:max-w-368 px-16 sm:px-0"><AvailabilityEdit :isEdit="isEdit" /></div>
</template>

<script lang="ts">
import cloneDeep from 'lodash/cloneDeep';
import pickBy from 'lodash/pickBy';
import Button from '../../../../components/button/Button.vue';
import StickyButton from '../../../../components/sticky_button/StickyButton.vue';
import AvailabilityEdit from './AvailabilityEdit.vue';
import AvailabilityTable from './AvailabilityTable.vue';

export default {
  name: 'AvailabilityDetails',
  components: { Button, AvailabilityEdit, AvailabilityTable, StickyButton },
  props: {
    sitterProfile: {
      default: () => {},
      type: Object,
    },
    isEdit: {
      default: false,
      type: Boolean,
    },
  },
  data(): any {
    return {
      availabilityData: cloneDeep(this.$store.getters['adventures/adventureDraft'].sitterAvailability),
    };
  },
  computed: {
    availabilitySitter(): any {
      return this.sitterProfile?.sitterAvailability;
    },
    hasAvailabilityData(): Boolean {
      return Object.keys(this.availabilityData || {}).some((day) => this.availabilityData[day]?.length > 0);
    },
  },
  mounted() {
    const pickedDays = pickBy(this.availabilitySitter, (day) => Array.isArray(day) || day === null);
    if (this.availabilityData === null && Object.keys(pickedDays).length > 0) {
      this.availabilityData = pickedDays;
      this.$store.dispatch('adventures/updateStore', { sitterAvailability: pickedDays });
    }
  },
  methods: {
    submitForm(): void {
      this.$router.push({ path: '/adventures/new/review' });
    },
  },
};
</script>
